import { render } from "./BillingComponent.vue?vue&type=template&id=545a61ee"
import script from "./BillingComponent.vue?vue&type=script&lang=js"
export * from "./BillingComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__